// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 3442) return "static/chunks/3442-f345a3b10f199be2.js";
	if (chunkId === 539) return "static/chunks/539-82dd8530fe6cf407.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"3657":"64afcc98","3931":"8c962df2","5727":"b320ced7","7667":"75f17bbb","8566":"fa008626"}[chunkId] || chunkId) + "." + {"1034":"8f81a116d79858a1","3657":"98cfc5b3d89d3a38","3931":"1fb9640fde1b26c8","5727":"9435f1a5e00b7379","6026":"8cb39f4c40f8c2d7","6901":"7ee017a099e301e5","7667":"c82765e943eea81d","8566":"1969ef6bd37f3fc2"}[chunkId] + ".js";
};